import React, { memo } from 'react';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { NAVIGATION_ITEM_ID } from '../../common/constants.tsx';
import { TopLevelErrorBoundary } from '../../common/ui/error-boundary/index.tsx';

const HelpComponent = importCond<typeof import('./help-new.tsx'), typeof import('./help-old.tsx')>(
	'nav_help_icon_vc90_top_offender_improvements',
	'./help-new.tsx',
	'./help-old.tsx',
);

const MemoizedHelpWithErrorBoundary = memo(() => (
	<TopLevelErrorBoundary id={NAVIGATION_ITEM_ID.HELP}>
		<HelpComponent />
	</TopLevelErrorBoundary>
));

const HelpWithErrorBoundaryOld = () => (
	<TopLevelErrorBoundary id={NAVIGATION_ITEM_ID.HELP}>
		<HelpComponent />
	</TopLevelErrorBoundary>
);

const HelpWithErrorBoundary = componentWithFG(
	'nav_help_icon_vc90_top_offender_improvements',
	MemoizedHelpWithErrorBoundary,
	HelpWithErrorBoundaryOld,
);

export { HelpWithErrorBoundary as Help };
